<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qy5hMp/image/9781398481114.jpg?1708094026133" alt="This image is the cover for the book The Adventures of Three Raindrop Friends"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Adventures of Three Raindrop Friends
      </h1>
      <p class="bookDescription body article font2">
        <p>Three Raindrop friends fall to the earth from the clouds during a storm. Each raindrop begins a different and exciting adventure on earth. One of our adventurers travels through a storm drain and ends up in the bright blue ocean. Another one of our characters gets gulped down by a dog and travels through the dog. Our last character travels up through a tree, getting to know the tree's history and the impact of clearing forests for development. This is a story about the excitement of experiencing and learning about new and important things.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Rush
      </h2>
      
      <p class="authorDescription body article">Mark is married with three children.  He lives in Perth, Australia. He works offshore in the Timor Sea, north of Australia, as an offshore facility manager. He spent 13 years living and working in the Pilbara region of western Australia, working in the resource sector.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bd212752